import type { CollectedIntegrationConfig } from '@cli-types/next-adapter/runtime.js'
import { resolvePasswordEnvValue } from './resolve-password-env-value.js'

export async function collectVercelBlobConfig(cwd: string): Promise<CollectedIntegrationConfig> {
  const overwriteEnvKeys = new Set<string>()
  const token = await resolvePasswordEnvValue({
    cwd,
    key: 'BLOB_READ_WRITE_TOKEN',
    message: 'Vercel Blob read-write token (from the store on vercel.com/dashboard/stores)',
    cancelMessage: 'Vercel Blob configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim()) {
        return 'Enter a Vercel Blob read-write token.'
      }
    }
  })

  return {
    sections: [
      {
        header: 'Storage (Vercel Blob)',
        vars: [{ key: 'BLOB_READ_WRITE_TOKEN', value: token.trim() }]
      }
    ],
    overwriteKeys: overwriteEnvKeys
  }
}
